import { render, staticRenderFns } from "./newOaWorkflowManageList.vue?vue&type=template&id=3a695b56&scoped=true"
import script from "./newOaWorkflowManageList.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowManageList.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowManageList.vue?vue&type=style&index=0&id=3a695b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a695b56",
  null
  
)

export default component.exports